export default [
  {
    type: 'group',
    key: 'main',
    name: 'Основные настройки',
    cards: [
      {
        key: 'users',
        name: 'Пользователи',
        icon: 'user',
        to: '{{matchUrl}}/users',
        description: 'Управление пользователями',
      },
    ],
  },
]